import { render, staticRenderFns } from "./DifficultyRange.vue?vue&type=template&id=37f1e7cc"
import script from "./DifficultyRange.vue?vue&type=script&lang=js"
export * from "./DifficultyRange.vue?vue&type=script&lang=js"
import style0 from "./DifficultyRange.vue?vue&type=style&index=0&id=37f1e7cc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports